import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
    MatDialogRef,
    MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RecaptchaComponent } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { PasswordGeneratorService } from '../../Services/password-generator.service';
import { phoneNumber } from '../../Validators/phone-number.validator';
import { AspiranteService } from '../../Modules/Aspirantes/Services/aspirante.service';
import { Permission } from '../../Services/authenticator.service';
import { Aspirante } from '../../Interfaces/aspirante.interface';
import { EncryptorService } from '../../Services/encryptor.service';
@Component({
    selector: 'app-dialog-nuevo-aspirante',
    templateUrl: './dialog-nuevo-aspirante.component.html',
    styleUrls: ['./dialog-nuevo-aspirante.component.css'],
    standalone: false
})
export class DialogNuevoAspiranteComponent implements OnInit {
    index: number = -1;
    no_solicitud: number = 1234;
    password: string;
    periodo: string = '20253';
    formSol: FormGroup = this.formBuilder.group({
        nombreAspirante: ['', [Validators.required, Validators.maxLength(50)]],
        apellidoPaternoAspirante: [
            '',
            [Validators.required, Validators.maxLength(50)],
        ],
        apellidoMaternoAspirante: [
            '',
            [Validators.required, Validators.maxLength(50)],
        ],
        CURPAspirante: [
            '',
            [
                Validators.required,
                Validators.pattern(
                    /^[A-Za-z]{4}\d{6}[A-Za-z]{6}[A-Za-z0-9]\d$/
                ),
            ],
        ],
        telefonoAspirante: ['', [Validators.required, phoneNumber]],
        correoAspiranteUsuario: ['', [Validators.required]],
        correoAspiranteDominio: ['', [Validators.required]],
        robot: ['', Validators.required],
    });

    public hole: boolean;
    public robot: boolean;

    @ViewChild('captcha') captcha: RecaptchaComponent;

    siteKey: string = environment.recaptcha.siteKey;
    posgrado: boolean;
    darkMode: boolean;

    constructor(
        public dialogRef: MatDialogRef<DialogNuevoAspiranteComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            posgrado: boolean;
            darkMode: boolean;
        },
        private formBuilder: FormBuilder,
        private passwordGenerator: PasswordGeneratorService,
        private snackBar: MatSnackBar,
        private aspirantesService: AspiranteService,
        private encrytorService: EncryptorService
    ) {
        this.posgrado = data?.posgrado ?? false;
        this.darkMode = data?.darkMode ?? false;
    }

    ngOnInit(): void { }

    continuar() {
        this.index = 0;
        this.dialogRef.disableClose = true;
    }

    aceptar() {
        this.dialogRef.close();
    }

    guardar() {
        this.robot = true;
        const formValues = this.formSol.value;
        this.password = this.passwordGenerator.generatePassword();
        this.formSol.disable();
        const aspirante: Aspirante = {
            periodo: this.periodo,
            no_solicitud: 0,
            apellido_paterno: formValues.apellidoPaternoAspirante,
            apellido_materno: formValues.apellidoMaternoAspirante,
            nombre_aspirante: formValues.nombreAspirante,
            curp: formValues.CURPAspirante.toUpperCase(),
            correo_electronico:
                formValues.correoAspiranteUsuario +
                '@' +
                formValues.correoAspiranteDominio,
            telefono: formValues.telefonoAspirante,
            fecha_registro: new Date(),
            pasos_completados: 0,
            online: false,
        };

        if (this.posgrado) {
            aspirante.posgrado = this.posgrado;
        }

        this.aspirantesService
            .existeSol(formValues.CURPAspirante.toUpperCase(), this.periodo)
            .subscribe((permiso: Permission) => {
                if (permiso.access) {
                    this.aspirantesService
                        .createAcceso({
                            no_solicitud: 0,
                            periodo: this.periodo,
                            password: this.encrytorService.encrypt(
                                this.password
                            ),
                        })
                        .subscribe(
                            (acceso) => {
                                aspirante.no_solicitud = acceso.no_solicitud;
                                this.no_solicitud = aspirante.no_solicitud;
                                this.aspirantesService
                                    .createSol(aspirante)
                                    .subscribe((sol) => {
                                        this.index = 1;
                                    });
                            },
                            (error) => {
                                this.snackBar.open(
                                    `Solicitud no procesada, intente mas tarde.`,
                                    "🤖",
                                    {
                                        duration: 5000,
                                        panelClass: 'snack-error-message',
                                    }
                                );
                                this.formSol.enable();
                            }
                        );
                } else {
                    this.snackBar.open(
                        'Ya tienes una solicitud registrada',
                        "🤖",
                        {
                            duration: 5000,
                            panelClass: 'snack-error-message',
                        }
                    );
                    this.formSol.enable();
                }
            });
    }

    onNoClick() {
        this.dialogRef.close();
    }

    resolved(event: any) {
        console.log(event);
        if (event) {
            this.formSol.controls.robot.setValue(event);
        }
    }
}
